import { ENVIRONMENT } from '../../../environment';
import { useAuthContext } from '../../../auth/auth-provider';
import { LearningApi } from '../../../services/learning-api';

const { baseUrl } = ENVIRONMENT.publicGateway;

export const useLearningApi = () => {
  const { getIdToken } = useAuthContext();
  return new LearningApi({ baseUrl, getAuthToken: getIdToken });
};
